module.exports = __webpack_public_path__ + "img/DNK.c435371a.png";